module.exports = __webpack_public_path__ + "static/media/home-research-meets-technology.b6d146be.png";